import React from "react";
import SimulatoreWizard from "@/components/SimulatoreWizard";
import { Sparkles } from "lucide-react";
import SEO from "@/components/SEO";

export default function Simulatore() {
  return (
    <div className="pt-32 pb-24 md:pt-40 md:pb-32">
      <SEO
        title="Analizzatore di Progetto AI — Napoli e provincia | Ri.Sco."
        description="Descrivi il tuo intervento edilizio e ricevi un'analisi qualitativa AI: fasi di lavoro, permessi tipici (CILA, SCIA), voci di costo, tempi indicativi e bonus fiscali applicabili. Sopralluogo gratuito con Ri.Sco. a Napoli."
        path="/simulatore"
      />
      <div className="container-x max-w-4xl">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 overline mb-4">
            <Sparkles className="w-3 h-3" /> Analizzatore di Progetto AI
          </div>
          <h1
            className="font-heading text-5xl sm:text-6xl md:text-7xl lg:text-8xl tracking-tighter text-risco-ink leading-[0.95]"
            data-testid="simulatore-page-title"
          >
            <span className="font-display italic">Il tuo progetto,</span>
            <br />
            analizzato dall'AI
          </h1>
          <p className="text-stone-600 mt-8 max-w-2xl text-lg leading-relaxed">
            Rispondi a poche domande sul tuo intervento: la nostra AI produce un'analisi
            qualitativa con fasi di lavoro, permessi tipici, voci di costo che comporranno
            il preventivo e tempi indicativi del cantiere. Nessun importo — solo una base
            concreta per il sopralluogo gratuito con i nostri tecnici.
          </p>
        </div>
        <SimulatoreWizard />
      </div>
    </div>
  );
}
